import React from "react";
import Helpers from "../../helpers/shared.helper";

const Skeleton = ({ width, height, mobWidth, mobHeight }) => {
  const isMobile = Helpers.isMobile();

  if (!mobHeight) mobHeight = height;
  if (!mobWidth) mobWidth = width;

  return (
    <div
      className="skeleton-loader"
      style={{
        width: isMobile ? mobWidth : width,
        height: isMobile ? mobHeight : height,
      }}
    ></div>
  );
};

export default Skeleton;
